export const NAME = 'OnTimePerformance';



// WEBPACK FOOTER //
// ./modules/OnTimePerformance/redux/constants.js